import { apiRequest, buildUrlWithParams } from "./api-client";

export async function getTransfers(
  shopId: string,
  filters?: {
    page?: number;
    limit?: number;
    direction?: "sent" | "received";
    status?: string;
    search?: string;
    startDate?: string;
    endDate?: string;
  },
): Promise<{ transfers: any[]; total: number }> {
  const url = buildUrlWithParams(
    `/api/shops/${shopId}/transfers`,
    filters as Record<string, string | number | undefined>,
  );
  return apiRequest(url);
}

export async function getTransfer(
  shopId: string,
  id: string,
): Promise<any> {
  return apiRequest(`/api/shops/${shopId}/transfers/${id}`);
}

export async function createTransfer(
  shopId: string,
  data: {
    shopDestinationId: string;
    notes?: string;
    items: {
      inventoryId: string;
      productId: string;
      quantity: number;
      unitCost?: string;
      batchNumber?: string;
    }[];
  },
): Promise<any> {
  return apiRequest(`/api/shops/${shopId}/transfers`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

export async function sendTransfer(
  shopId: string,
  id: string,
): Promise<any> {
  return apiRequest(`/api/shops/${shopId}/transfers/${id}/send`, {
    method: "POST",
  });
}

export async function receiveTransfer(
  shopId: string,
  id: string,
  data: {
    items: { id: string; quantityReceived: number }[];
    notes?: string;
  },
): Promise<any> {
  return apiRequest(`/api/shops/${shopId}/transfers/${id}/receive`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

export async function cancelTransfer(
  shopId: string,
  id: string,
): Promise<any> {
  return apiRequest(`/api/shops/${shopId}/transfers/${id}/cancel`, {
    method: "POST",
  });
}

export async function getAvailableDestinations(
  shopId: string,
): Promise<any[]> {
  return apiRequest(`/api/shops/${shopId}/transfers/available-destinations`);
}
